var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.125 -0.00012207L17.116 8.23562L26.25 9.45354L19.5825 15.7614L21.2367 24.7499L13.125 20.4126L5.0133 24.7499L6.6675 15.7614L0 9.45354L9.13404 8.23562L13.125 -0.00012207Z","fill":"currentColor"}));
}

StarInline.defaultProps = {"width":"27","height":"25","viewBox":"0 0 27 25","fill":"none"};

module.exports = StarInline;

StarInline.default = StarInline;
